import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('epg_session_id');
  if (!sessionId) {
    sessionId = 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    sessionStorage.setItem('epg_session_id', sessionId);
  }
  return sessionId;
};

// Get UTM parameters from URL
const getUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign')
  };
};

// Track an event
export const trackEvent = async (eventType, page, metadata = {}) => {
  try {
    const utm = getUtmParams();
    await axios.post(`${API}/analytics/track`, {
      event_type: eventType,
      page: page,
      source: utm.source,
      medium: utm.medium,
      campaign: utm.campaign,
      referrer: document.referrer,
      session_id: getSessionId(),
      metadata: metadata
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.debug('Analytics tracking failed:', error);
  }
};

// Hook to track page views
export const usePageTracking = (pageName) => {
  useEffect(() => {
    trackEvent('page_view', pageName || window.location.pathname);
  }, [pageName]);
};

// Track form submission
export const trackFormSubmit = (page, formType = 'contact') => {
  trackEvent('form_submit', page, { form_type: formType });
};

// Track video play
export const trackVideoPlay = (page, videoName = '') => {
  trackEvent('video_play', page, { video_name: videoName });
};

// Track signup start
export const trackSignupStart = (page) => {
  trackEvent('signup_start', page);
};

// Track signup complete
export const trackSignupComplete = (page) => {
  trackEvent('signup_complete', page);
};

// Track button click
export const trackButtonClick = (page, buttonName) => {
  trackEvent('button_click', page, { button_name: buttonName });
};

export default usePageTracking;
